"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIconButtonStyles = void 0;
var _react = require("react");
var _useInteractableHeight = require("@cbhq/cds-common/hooks/useInteractableHeight");
const useIconButtonStyles = compact => {
  const height = (0, _useInteractableHeight.useInteractableHeight)(compact);
  return (0, _react.useMemo)(() => ({
    '--interactable-height': `${height}px`
  }), [height]);
};
exports.useIconButtonStyles = useIconButtonStyles;